import { HeartPulse, Zap, ShieldAlert, Stethoscope } from "lucide-react";
import { Reveal } from "./shared";

const SERVICES = [
  {
    icon: HeartPulse,
    title: "Hands-on CPR",
    body: "Proper depth, proper rhythm — everyone practises on training manikins until it feels natural.",
  },
  {
    icon: Zap,
    title: "Confident AED use",
    body: "Every participant handles a training defibrillator, so the real thing never feels unfamiliar.",
  },
  {
    icon: ShieldAlert,
    title: "Choking response",
    body: "Recognise it fast and respond effectively — one of the most common workplace emergencies.",
  },
  {
    icon: Stethoscope,
    title: "Real medical cases",
    body: "Taught through real scenarios drawn from frontline and event medicine.",
  },
];

export const WhatWeDo = () => (
  <section id="what-we-do" className="px-4 py-24 sm:px-6 lg:px-8" data-testid="what-we-do-section">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mx-auto max-w-3xl text-center">
        <h2 className="font-display text-3xl font-bold tracking-tight text-[#14231B] sm:text-4xl lg:text-5xl">
          <span className="text-[#1E7B4F]">Life-saving</span> training
        </h2>
        <p className="mt-4 text-lg text-[#5F6E63]">
          One-hour sessions that fit around your working day and give your staff the practical
          skills — and confidence — to save lives.
        </p>
      </Reveal>
      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className="h-full">
            <div className="h-full rounded-3xl border border-[#E7E3D9] bg-white p-8 shadow-sm hover:shadow-md hover:-translate-y-1 transition-[box-shadow,transform] duration-300">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#1E7B4F]/10">
                <s.icon className="h-6 w-6 text-[#1E7B4F]" />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-[#14231B]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#5F6E63]">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
